import { cn } from "@/lib/utils"

// BOOTH "live" indicator — a small, sleek lozenge (pill, not a full circle)
// with a soft pulsing ripple + a gently breathing core. Reusable replacement
// for round status dots across dashboards, cards, badges, etc. Brand green by
// default. Both layers are absolutely positioned so they get a real footprint
// from the inline-block wrapper (a plain inline span ignores w/h).
// Colour arrives the same two ways as its static sibling Lozenge: a `bg-*`
// class in className for a theme token, or `color` for a literal. A caller
// passing a class used to get the emerald default anyway, since the inline
// fill on both layers beat it.
export function PulseDot({ color = "#10b981", className }: { color?: string; className?: string }) {
  // The fill lives on the two inner layers, not the wrapper, so a `bg-*` class
  // has to be forwarded to them — but ONLY that class. Handing the whole
  // className down would put the caller's positioning (mt-2, shrink-0) on two
  // absolutely-positioned children as well.
  const bgClass = (className ?? "").split(/\s+/).filter((c) => c.startsWith("bg-")).join(" ")
  const fill = bgClass ? undefined : { backgroundColor: color }
  return (
    <span className={cn("relative inline-block h-1.5 w-2 flex-shrink-0 align-middle", className)} aria-hidden="true">
      <span className={cn("pulse-dot-ripple absolute inset-0 rounded-full", bgClass)} style={fill} />
      <span className={cn("pulse-dot-core absolute inset-0 rounded-full", bgClass)} style={fill} />
    </span>
  )
}
